import { GridRowId } from '@mui/x-data-grid-pro'
import { bulkActionErrors } from '../../constants'
import { BulkUpdateStatusDTO } from '../../typings'

export function formatErrors(dto?: BulkUpdateStatusDTO) {
  const errors = new Map<GridRowId, string[]>()

  if (!!dto) {
    const { alreadyClosedEntities, nonClosureEntities } = dto

    const closed = alreadyClosedEntities === null ? [] : alreadyClosedEntities

    const hasAlreadyClosed = closed.length > 0

    closed.map((e) => {
      errors.set(e.entityId, [bulkActionErrors.closedWinStatus.closed.rowError])
    })

    const nonClosures = nonClosureEntities === null ? [] : nonClosureEntities

    const hasUnableToClose = nonClosures.length > 0

    nonClosures.map((e) => {
      errors.set(e.entityId, [
        bulkActionErrors.closedWinStatus.requirements.rowError,
      ])
    })

    return {
      errors,
      hasAlreadyClosed,
      hasUnableToClose,
    }
  }

  return {
    errors,
    hasAlreadyClosed: false,
    hasUnableToClose: false,
  }
}
